import { HTMLProps } from "react";
import { cn } from "../utils/utils";

interface AvatarProps extends Omit<HTMLProps<HTMLImageElement>, "src"> {
  src?: string | null | URL;
  transparentColorOverride?: string;
}

export function Avatar({ src, className, ...rest }: AvatarProps) {
  const avatarSrc = src?.toString().trim() || "/default_avatar.webp";

  return (
    <img
      className={cn("h-12 w-12 shrink-0 select-none rounded-full object-cover object-top", className)}
      draggable="false"
      src={avatarSrc}
      alt="Avatar"
      {...rest}
    />
  );
}
